(function($) {
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', init)

  function init() {
      panelsContainerAdditionalAttributes.init()
  }
  
  const panelsContainerAdditionalAttributes = {
    panelsContainer: false,
    init() {
      this.panelsContainer = $('.cpb-panels-container')
      this.panelsContainer.attr('data-tabs-layout', CPB.getStore().getState().App.settings.layout)
      document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', this.setTabNegativeIndex.bind(this))
      document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', this.setTabNegativeIndex.bind(this))
    },
    setTabNegativeIndex() {
      const tabs = this.panelsContainer.find('.react-tabs__tab')
      let activeTabIndex = 0
      for(let i = 0; i < tabs.length; i++) {
        if(tabs.eq(i).hasClass('cpb-active')) {
        	activeTabIndex = i
            break
        }
      }
      this.panelsContainer.attr('data-active-tab-index-from-end', tabs.length - 1 - activeTabIndex)
    }
  }
})(jQuery)